import { formatErrorForDisplay } from '@/components/SearchAssistant/helpers/ui';
import { Alert, Box, Button, Typography } from '@mui/material';
import { Component } from 'react';

const styles = {
  errorContainer: {
    padding: (theme) => theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: (theme) => theme.spacing(2),
  },
  errorTitle: {
    fontWeight: 600,
  },
  retryButton: {
    marginTop: (theme) => theme.spacing(1),
  },
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    console.error(error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
    console.error(error, errorInfo);
  }

  handleRetry() {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
  }

  render() {
    if (this.state.hasError) {
      const { fallback: Fallback } = this.props;

      if (Fallback) {
        return <Fallback error={this.state.error} retry={this.handleRetry.bind(this)} />;
      }

      return <DefaultErrorFallback error={this.state.error} retry={this.handleRetry.bind(this)} />;
    }

    return this.props.children;
  }
}

const DefaultErrorFallback = ({ error, retry }) => {
  const errorDisplay = formatErrorForDisplay(error, process.env.NODE_ENV === 'development');

  if (!errorDisplay) return null;

  return (
    <Box sx={styles.errorContainer}>
      <Alert severity="error" sx={{ width: '100%' }}>
        <Typography variant="h6" sx={styles.errorTitle}>
          {errorDisplay.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {errorDisplay.message}
        </Typography>
        {errorDisplay.details && (
          <Typography variant="caption" component="pre" sx={{ mt: 1, fontSize: '0.7rem' }}>
            {errorDisplay.details}
          </Typography>
        )}
      </Alert>
      <Button variant="contained" onClick={retry} sx={styles.retryButton} size="small">
        Try Again
      </Button>
    </Box>
  );
};

export { ErrorBoundary };
